document.addEventListener("DOMContentLoaded", function() {
  const freeShippingBars = document.querySelectorAll('.free-shipping-bar');

  freeShippingBars.forEach(freeShippingBar => {
    const totalPrice = parseInt(freeShippingBar.getAttribute('total-price'), 10);
    const threshold = parseInt(freeShippingBar.getAttribute('threshold'), 10);
    const percentage = Math.min((totalPrice / threshold) * 100, 100); // Calculate percentage, capped at 100%

    // Dynamically set the width of the ::after pseudo-element
    freeShippingBar.style.setProperty('--progress-width', `${percentage}%`);
  });
});
